import styled from 'styled-components';
import './index.css';
import ResetStyles from './components/shared/resetStyles';
import SectionTop from './components/section/SectionTop';
import SectionBrandStory from "./components/section/SectionBrandStory";
import SectionCoverModel from "./components/section/SectionCoverModel";
import SectionCollaborationDress from './components/section/SectionCollaborationDress';
import SectionOriginalDress from './components/section/SectionOriginalDress';
import SectionCollaborationAccessory from './components/section/SectionCollaborationAccessory';
import SectionLifeStyleItem from './components/section/SectionLifeStyleItem';
import SectionShopList from './components/section/SectionShopList'
import SectionProduceCafe from './components/section/SectionProduceCafe';
import SectionAppBanner from './components/section/SectionAppBanner';
import SectionMedia from './components/section/SectionMedia';

const AppContainer = styled.section`
  max-width: ${({ pc }) => (pc && '550px')};
  margin: ${({ pc }) => (pc ? 'auto' : '0')};
`

function App() {
  const isPc = window.innerWidth > 768;

  return (
    <AppContainer pc={isPc}>
      <ResetStyles />
      <SectionTop />
      <SectionBrandStory />
      <SectionCoverModel />
      <SectionAppBanner />
      <SectionMedia pc={isPc} />
      <SectionCollaborationDress />
      <SectionOriginalDress />
      <SectionCollaborationAccessory />
      <SectionLifeStyleItem />
      <SectionShopList pc={isPc} />
      <SectionProduceCafe />
      
    </AppContainer>
  );
}

export default App;
